module.exports = __webpack_public_path__ + "img/banner-left-btn.48d1051e.svg";